module.exports = __webpack_public_path__ + "static/media/Dene-bw.adafd7c7.png";